export const validateUserPermissions = ({
    user = { permissions: [""] },
    permissions = [""],
    some = false,
}) => {
    const userPermissions = Object.keys(user.permissions);

    if (permissions.length > 0 && !!some) {
        const hasSomePermissions = permissions.some((permission) => {
            return user && userPermissions.includes(permission);
        });

        if (!hasSomePermissions) {
            return false;
        }
    }

    if (permissions.length > 0 && !some) {
        const hasAllPermissions = permissions.every((permission) => {
            return user && userPermissions.includes(permission);
        });

        if (!hasAllPermissions) {
            return false;
        }
    }

    return true;
};
